import { Vue, newVue } from '@/config/vue'

On.VueInit({
  controller: 'profiles',
  init() {
    const Profile = Vue.component('profile', () =>
      import(/* webpackChunkName: "account-profile" */ './Profile/Profile.vue')
    )
    newVue({
      render: h => h(Profile),
      mount: '.js-vue-account-profile',
      stores: ['territories'],
    })
  },
})

On.VueInit({
  controller: 'orders',
  action: 'index',
  init() {
    const Orders = Vue.component('orders', () =>
      import(/* webpackChunkName: "account-orders" */ './Orders/Orders.vue')
    )
    newVue({
      render: h => h(Orders),
      mount: '.js-vue-account-orders',
    })
  },
})

On.VueInit({
  controller: 'store_credits',
  action: 'index',
  init() {
    const StoreCredits = Vue.component('store_credits', () =>
      import(/* webpackChunkName: "account-store-credits" */ './StoreCredits/StoreCredits.vue')
    )
    newVue({
      render: h => h(StoreCredits),
      mount: '.js-vue-account-store-credits',
      stores: ['account'],
    })
  },
})
